import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';

import * as fromState from '@core/store/state/recorder/recorder.state';
import * as fromActions from '@core/store/state/recorder/recorder.actions';

// models
import { RecordingConfig } from '@core/models/recording-config.model';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';
import { NotificationData } from "@core/store/models/notifications.interface";
import { Record } from '@core/store/models/recorder.class';
// services
import { NotificationsService } from '@core/services/notifications/notifications.service';

@Injectable({
    providedIn: 'root'
})

export class RecorderService {

    public readonly TYPES = NotificationsContextEnum;

    constructor(private store: Store<fromState.Recorder>,private notifSrv:NotificationsService){}

    // SELECTORS
    getStatus = () :  Observable<any> => this.store.select(fromState.statusSelector);

    getMediaRecorder = () : Observable<any> => this.store.select(fromState.mediaRecorderSelector);
    
    getNotificationData = () : Observable<NotificationData> => this.store.select(fromState.notificationDataSelector);

    getRecordedData = () : Observable<Record> => this.store.select(fromState.recordDataSelector);

    getStreamChunks = () : Observable<Blob[]> => this.store.select(fromState.chunksSelector);
    
    // ACTIONS
    /**
     * Start the recording of the data from devices according config
     * @param config : the options with the devices ids and screen to record
     * @param data : the required info to send to the notification.
     * @returns void in this case.
     */
    startRecording = (config: RecordingConfig, data: NotificationData ) => 
        this.store.dispatch(new fromActions.Init( config, data ));

    /**
     * Stop the recording
     * @returns void in this case
     */
    stopRecording = () => this.store.dispatch(new fromActions.Stop());

    /**
     * Empty the data on the recorder store to set initial state
     * @returns void
     */
    clear = () => this.store.dispatch(new fromActions.Clear())

    /**
     * Empty the data on the recorder store to set initial state
     * @returns void
     */
    finish = (result: boolean) => this.store.dispatch(new fromActions.Finish(result))
    /**
     * this code from here is only for debug and development purposes to test 
     * video mime supprted in the browsers
     */

    private getSupportedMimeTypes(media, types, codecs) {
        const isSupported = MediaRecorder.isTypeSupported;
        const supported = [];
        types.forEach((type) => {
          const mimeType = `${media}/${type}`;
          codecs.forEach((codec) => [
              `${mimeType};codecs=${codec}`,
              `${mimeType};codecs=${codec.toUpperCase()}`,
              // /!\ false positive /!\
              // `${mimeType};codecs:${codec}`,
              // `${mimeType};codecs:${codec.toUpperCase()}` 
            ].forEach(variation => {
              if(isSupported(variation)) 
                  supported.push(variation);
          }));
          if (isSupported(mimeType))
            supported.push(mimeType);
        });
        return supported;
      };
      
      // Usage ------------------
      testBrowserMimeTypesSupproted(){
      
        const videoTypes = ["webm", "ogg", "mp4", "x-matroska"];
        const audioTypes = ["webm", "ogg", "mp3", "x-matroska"];
        const codecs = ["should-not-be-supported","vp9", "vp9.0", "vp8", "vp8.0", "avc1", "av1", "h265", "h.265", "h264", "h.264", "opus", "pcm", "aac", "mpeg", "mp4a"];
        
        const supportedVideos = this.getSupportedMimeTypes("video", videoTypes, codecs);
        const supportedAudios = this.getSupportedMimeTypes("audio", audioTypes, codecs);
        
        console.log('-- Top supported Video : ', supportedVideos[0])
        console.log('-- Top supported Audio : ', supportedAudios[0])
        console.log('-- All supported Videos : ', supportedVideos)
        console.log('-- All supported Audios : ', supportedAudios)
      }
}
